import { useEffect } from 'react';
import "../../App.css";
import "../../Events.css";
import React from "react";
import { Helmet } from "react-helmet";
import colors from "../../data/colors";

export default function HomeMidSeason() {

  useEffect(() => {
    console.log("Midseason mode active");
  }, []);

  return (
    <>
      <div id="container">
        <Helmet>
          <title>Netflix Series FYC</title>
          <meta name="description" content="Netflix Series FYC" />
        </Helmet>

        <main>
          <div
            className={"d-flex w-100 align-items-center justify-content-center"}
            style={{
              minHeight: "100vh",
              background: `linear-gradient(90deg, rgba(${colors[0].dark.rgb},.33) 0%, rgba(${colors[0].dark.rgb},0) 50%, rgba(${colors[0].dark.rgb},.33) 100%)`,
            }}
          >
            <h3 className={"text-center"} style={{ maxWidth: 400 }}>
              We'll be back soon with more of the shows you love.
            </h3>
          </div>
        </main>
      </div>
    </>
  );
}
